import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { useClient } from "../../context/ClientContext";

export const PhotoThumb = ({ path, testid, className = "" }) => {
  const { fileUrl } = useClient();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`block aspect-square w-full overflow-hidden rounded-lg border bg-muted ${className}`}
        data-testid={testid}>
        <img src={fileUrl(path)} alt="Item" loading="lazy" className="h-full w-full object-cover" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[95vw] p-2 sm:max-w-3xl" data-testid={`${testid}-full`}>
          <DialogTitle className="sr-only">Item photo</DialogTitle>
          <img src={fileUrl(path)} alt="Item full size" className="max-h-[80vh] w-full rounded object-contain" />
        </DialogContent>
      </Dialog>
    </>
  );
};
